import {QueryClient} from '@tanstack/react-query';
import {FIREBASE_WEB_API_KEY_PRODUCTION} from '@cip/core/firebase';

const hostname = window.location.hostname;
// Custom (non-Firebase-Hosting) domains that serve the app AND the Firebase
// Auth helper at `<host>/__/auth/handler`, so `authDomain` can be the serving
// host to keep signInWithRedirect same-origin. pai.stanford.edu is PAI's
// custom domain; the cip-pai Firebase Hosting site is covered by the
// pattern below.
const isCS106A = hostname === 'cs106a.stanford.edu';
const isCodeInPlace = hostname === 'codeinplace.stanford.edu';
const isPai = hostname === 'pai.stanford.edu';
// The codeinplace-production Firebase Hosting sites that serve this bundle
// (see the webapp + PAI entries in firebase.json — keep in sync if sites are
// added or renamed). Each site serves the /__/auth/* handler natively on
// its default domains AND on its preview-channel domains
// (`<site>--<channel>-<hash>.web.app`), so the app's own hostname is a
// valid authDomain on all of them. Matching is anchored to these site
// names rather than all of *.web.app so hosts outside our project fall
// back to the default authDomain below.
const FIREBASE_HOSTING_SITES = [
  'codeinplace-production',
  'cip-webapp-dev',
  'cip-pai',
];
const isFirebaseHostingDomain = FIREBASE_HOSTING_SITES.some(
  site =>
    hostname === `${site}.web.app` ||
    hostname === `${site}.firebaseapp.com` ||
    (hostname.startsWith(`${site}--`) && hostname.endsWith('.web.app')),
);

// Use the app's own hostname as authDomain wherever the /__/auth/* handler
// is reachable on it (keeps signInWithRedirect cookies first-party). On
// codeinplace.stanford.edu / pai.stanford.edu that handler is proxied/served
// by the host platform; on Firebase Hosting domains it is native. Anywhere
// else, fall back to the project's default auth domain. The hostname must
// also be in Firebase Auth's authorized-domains list for redirect/email-link
// sign-in.

let prodAuthDomain = 'codeinplace-production.firebaseapp.com';
if (isCS106A || isCodeInPlace || isPai || isFirebaseHostingDomain) {
  prodAuthDomain = hostname;
}

// fake data that anyone can write to
const developmentFirebaseConfig = {
  apiKey: 'AIzaSyBuVNOhgT29akbMEqmDxC7JpmAPMPT9DG8',
  authDomain: 'codingplace2023.firebaseapp.com',
  projectId: 'codingplace2023',
  storageBucket: 'codingplace2023.appspot.com',
  messagingSenderId: '1078516885903',
  appId: '1:1078516885903:web:6c76352a03b62d53c483fa',
  measurementId: 'G-B1GM87LSSM',
};

const productionFirebaseConfig = {
  apiKey: FIREBASE_WEB_API_KEY_PRODUCTION,
  authDomain: prodAuthDomain,
  storageBucket: 'codeinplace-production.appspot.com',
  projectId: 'codeinplace-production',
  messagingSenderId: '809987214626',
  appId: '1:809987214626:web:7b84cbf8637ff7456de97b',
  measurementId: 'G-NDJSLLEQW2',
};

const developmentTypesenseConfig = {
  apiKey: 'fYyZJsb5QjeWoaxbCB0yCxr66jC4DbxQ',
  nodes: [
    {
      host: '3il5x7982gnc4a1mp-1.a1.typesense.net',
      port: 443,
      protocol: 'https',
    },
  ],
};

const productionTypesenseConfig = {
  apiKey: '39t7GJLtPpsVIGXloCrmFx6Avwr8t4iq',
  nodes: [
    {
      host: 'vt0hoib23975n4rlp-1.a1.typesense.net',
      port: 443,
      protocol: 'https',
    },
    {
      host: 'vt0hoib23975n4rlp-2.a1.typesense.net',
      port: 443,
      protocol: 'https',
    },
    {
      host: 'vt0hoib23975n4rlp-3.a1.typesense.net',
      port: 443,
      protocol: 'https',
    },
  ],
};

// WARNING: do not change this unless you know what you are doing.
export const isProduction = true;
export const typesenseServerConfig = isProduction
  ? productionTypesenseConfig
  : developmentTypesenseConfig;

export const firebaseConfig = isProduction
  ? productionFirebaseConfig
  : developmentFirebaseConfig;

export const queryClient = new QueryClient();
